export enum UIAdressStatus {
  ADRESSE_KORREKT = 'ADRESSE_KORREKT',
  ADRESSE_NICHT_VALIDIERT = 'ADRESSE_NICHT_GEFUNDEN',
  ADRESSE_NICHT_GEFUNDEN = 'ADRESSE_NICHT_GEFUNDEN',
  ADRESSE_KORRIGIERT = 'ADRESSE_KORRIGIERT',
}
